<template lang="html">
<div class="container">
  <div class="content">
    <div>
        <div class="field" v-if="!isAdding">
        <label class="label">Código</label>
        <p class="control">
          <input class="input" type="text" placeholder="Código" v-model="use_codigo" required :disabled='!isAdding'>
        </p>
      </div>
      <div class="field">
        <label class="label">Nome</label>
        <p class="control">
          <input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('nome')}" type="text" placeholder="Nome" name="nome" v-model="use_data.nome" required>
        </p>
      </div>

      <div class="field">
        <label class="label">Login</label>
        <p class="control">
          <input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('login')}" type="text" placeholder="Login" name="login" v-model="use_data.login" :disabled='!isAdding'>
        </p>
      </div>

      <div class="field">
        <label class="label">E-mail</label>
        <p class="control has-icons-left has-icons-right">
          <input v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email')}" type="text" placeholder="E-mail" name="email" v-model="use_data.email" :disabled='!isAdding'>
          <span class="icon is-small is-left">
            <i class="fa fa-envelope"></i>
          </span>
        </p>
      </div>

      <div class="field" v-if='!isAdding'>
        <label class="label">Token</label>
        <p class="control">
          <input class="input" type="text" placeholder="E-mail" v-model="use_data.token" :disabled='!isAdding' />
        </p>
      </div>

    <div class="field is-grouped">
      <p class="control">
        <button class="button is-primary" :disabled="errors.any()" @click.prevent="save">Salvar</button>
      </p>
    </div>

    </div>
  </div>
</div>
</template>

<script>
import swal from 'sweetalert2'
import { getUser, createUser, updateUser } from './users.service'
export default {
  name: 'AppUsersAddEdit',
  data () {
    return {
      use_codigo: '',
      use_data: {
        nome: '',
        login: '',
        email: '',
        token: ''
      }
    }
  },
  computed: {
    isAdding () {
      return !(this.$route.params.codUser || false)
    }
  },
  methods: {
    save () {
      if (this.isAdding) {
        const newUser = this.use_data
        createUser(newUser)
        .then(response => {
          if (response) {
            swal({
              title: 'Adição',
              text: 'Cadastro realizado com sucesso!',
              type: 'success',
              showLoaderOnConfirm: true
            })
            .then(() => {
              this.$router.push('/users')
            })
          }
        })
      } else {
        const codUser = this.$route.params.codUser
        const dataUser = {
          use_codigo: this.use_codigo,
          use_data: this.use_data
        }
        updateUser(codUser, dataUser)
        .then(response => {
          if (response) {
            swal({
              title: 'Edição',
              text: 'Cadastro atualizado com sucesso!',
              type: 'success',
              showLoaderOnConfirm: true
            })
            .then(() => {
              this.$router.push('/users')
            })
          }
        })
      }
    },
    loadUser () {
      if (!this.isAdding) {
        const codUser = this.$route.params.codUser
        getUser(codUser)
        .then(response => {
          this.use_codigo = response.use_codigo
          this.use_data = response.use_data
        })
      } else {
        this.use_data = {
          nome: '',
          login: '',
          email: '',
          token: ''
        }
      }
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// UsersAddEdit.vue?4f80755e